import React, { useEffect } from 'react'

export default () => {
  useEffect(() => {
    // hack to detect docusign signing completion
    // @ts-ignore
    if (parent && parent.docusignDone) parent.docusignDone()
  })

  return <div>Signing Complete. Please press the done button if you are not redirected</div>
}
